import React from 'react'
import { SocialIcon } from 'react-social-icons'

function SocialMedia({ links = [
  { label: 'LinkedIn', url: 'https://linkedin.com/' },
  { label: 'GitHub', url: 'https://github.com/' },
//   { label: 'Email', url: '44ash@gmail.com' },
], size = 50, containerStyle = {} }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginTop: '60px', marginBottom: '60px', ...containerStyle }}>
      {links.map((link) => (
        <SocialIcon
          key={link.label}
          url={link.url}
          style={{ height: size, width: size, transition: 'transform 0.3s' }}
          fgColor="#fff"
          onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.2)')}
          onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
        />
      ))}
    </div>
  )
}

export default SocialMedia
